import { APP_VERSION } from "../../appVersion";
import { getPageSize } from "./cursor";

function drawAppVersion(doc) {
  const { width } = getPageSize(doc);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text(`v${APP_VERSION}`, width - 10, 10, { align: "right" });
}

/**
 * Draws a simple page border and centered title. Intended to be used from autoTable hooks.
 */
export function drawPageChrome(doc, { title, border = true, titleY = 40, borderRect } = {}) {
  const { width } = getPageSize(doc);

  if (border) {
    const rect = borderRect || { x: 10, y: 45, w: 190, h: 235 };
    doc.rect(rect.x, rect.y, rect.w, rect.h);
  }

  if (title) {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(title, width / 2, titleY, null, null, "center");
    doc.setFont("helvetica", "normal");
  }
}

export function addPageNumbers(doc, { fontSize = 10, yOffset = 10 } = {}) {
  const totalPages = doc.internal.getNumberOfPages();
  const { width, height } = getPageSize(doc);

  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    drawAppVersion(doc);
    doc.setFontSize(fontSize);
    doc.setFont("helvetica", "normal");
    doc.text(`Page ${i} of ${totalPages}`, width / 2, height - yOffset, null, null, "center");
  }
}


